module.exports = __webpack_public_path__ + "img/248.0b6aef5e.jpg";